import React from 'react';
import Button from '../ui/Button';
import {useTranslation} from "react-i18next";
import './hero.css';

const Hero: React.FC = () => {
    const loginToMiniapp = () => {
        window.location.href = "https://account.kirenagainvest.com/login"
        };
    const registerToMiniapp = () => {
        window.location.href = "https://account.kirenagainvest.com/registration"
        };
    const { t } = useTranslation() as {
        t: (key: string, options?: any) => string;
    };
  return (
    <div>
      {/* Логотип с зелеными элементами - Полноэкранная секция */}
      <div className="h-screen flex items-center relative md:px-28 px-6 md:pt-20">
        <div className="flex relative w-full items-center">

          <div className="mb-2 absolute left-0 z-10">
            <h1 className="text-3xl md:text-7xl lg:text-8xl xl:text-9xl leading-[110%]">
              LIBERTY<br />
              INVESTMENT<br />
              KIRENAGA
            </h1>
            <p className="hidden md:block mt-2 md:text-4xl text-2xl">{t('subtitle')}</p>
          </div>


          {/* Зеленые графические элементы логотипа */}
          <div className="flex absolute items-center h-full
            md:left-1/2 md:w-5/12 z-0">
            <div className="relative w-full">
              <img 
                src={require('../../assets/images/logo.png')}
                alt="Logo design elements" 
                className="h-auto w-full px-6 md:px-0"
              />
            </div>
          </div>

        </div>

        <p className="absolute md:hidden text-400 top-[72%] md:text-4xl text-2xl ml-3">{t('subtitle')}</p>

      </div>
      
       {/* Главный раздел с предложением - Полноэкранная секция */}
       <div className="md:h-screen relative">
        <div className="hidden md:block absolute inset-0">
          <img 
            src={require('../../assets/images/first_wall.jpg')}
            alt="Family investing together" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-white bg-opacity-10"></div>
        </div>
        
        <div className="flex flex-col relative h-full items-start pt-0 md:py-44 md:pl-28 px-6 justify-between gap-16 md:gap-0 ">
            <h2 className="text-3xl md:text-6xl/tight font-bold uppercase md:centralizeBlock" dangerouslySetInnerHTML={{ __html: t('invest_title') }}>
            </h2>

            <div className="">
              <button 
                className="flex items-center justify-between bg-gray-800 text-[#D4FB00] font-bold py-4 px-10 rounded-xl shadow-md"
                style={{
                  backgroundColor: 'rgba(45, 45, 45, 0.95)'
                }}
                onClick={() => registerToMiniapp()}
              >
                <span className="text-2xl font-semibold font-druk tracking-wide">{ t('n_from_50_usdt') }</span>
              </button>
            </div>
        </div>
      </div>
      
      {/* Слоган "Изменяй реальность" - Полноэкранная секция */}
      <div className="flex flex-col justify-between md:px-28 md:pt-0 pt-12">
        <div className="pt-16 px-6 md:px-0 md:pt-24">
          <h2 className="text-2xl sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-12" dangerouslySetInnerHTML={{ __html: t('slogan') }}>

          </h2>
        </div>
        
        {/* SVG блоки вместо статистических блоков */}
        <div className="grid md:grid-cols-3 gap-0 pb-20
        px-0    md:px-8    lg:px-16    xl:px-28
        text-2xl md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl

        ">
        <div className="relative">
            <img 
            src={require('../../assets/images/adv_green.svg').default} 
            alt="Работаем 8 лет"
            className="w-full h-auto"
            />
            <div className="absolute inset-0 flex flex-col text-center justify-center gap-10
                text-4xl md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl
            ">
                <p className="font-druk font-bold text-black">{t('years')}</p>
                <p className="font-druk font-bold text-black">{t('years_count')}</p>
            </div>
        </div>
        <div className="relative">
            <img 
            src={require('../../assets/images/adv_dark.svg').default}
            alt="Клиентов 1000+" 
            className="w-full h-auto"
            />
            <div className="absolute inset-0 flex flex-col text-center justify-center gap-10
            
            text-4xl md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl
            ">
            <p className="font-druk font-bold mb-1 text-white">{t('clients')}</p>
            <p className="font-druk font-bold text-white">1000+</p>
            </div>
        </div>
        <div className="relative">
            <img 
            src={require('../../assets/images/adv_beige.svg').default}
            alt="Стран 5+" 
            className="w-full h-auto"
            />
            <div className="absolute inset-0 flex flex-col text-center justify-center gap-10
            text-4xl md:text-xl lg:text-3xl xl:text-4xl 2xl:text-5xl
            ">
            <p className="font-druk font-bold text-white">{t('countries')}</p>
            <p className="font-druk font-bold text-white">5+</p>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
